import barcodePrintTags from '@/utils/barcode/barcodePrintTags';
import Barcode from 'react-barcode';

const BarcodePreview = ({ format }) => {
  return (
    <div className="barcode-container">
      <div
        className="barcode-details"
        style={{
          display: 'flex',
          // width: '70mm',
          // height: '13mm',
        }}
      >
        <div
          className="barcode-item"
          style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '35mm',
            height: '16mm',
            /*margin-left: 66mm;*/
            pageBreakInside: 'avoid',
            gap: '0.5px',
          }}
        >
          <p
            style={{
              marginTop: '3px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '30px',
              fontSize: '10px',
              fontWeight: 'bold',
              color: 'black',
            }}
          >
            <span>{`${format.heading}`}</span>
            <span>00K</span>
          </p>

          <Barcode
            fontSize={30}
            value="ABC456"
            format="CODE128"
            width={2}
            height={50}
          />
        </div>

        <div
          className="barcode-secondItem"
          style={{
            width: '40%',
            display: 'flex',
            flexDirection: 'column',
            /* column-gap: 5px; */
            // marginLeft: '-10mm',
            /* grid-template-columns: 80% 80%; */
            /* gap: 2px; */
            alignSelf: 'center',
          }}
        >
          {format?.tags.map((item, index) => {
            return (
              <div key={index}>
                <p
                  style={{
                    margin: 0,
                    fontSize: '10px',
                    color: 'black',
                    fontWeight: 'bold',
                    width: '100%',
                    display: 'flex',
                    gap: '8px',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>
                    {
                      barcodePrintTags.find((option) => option.value === item)
                        ?.label
                    }
                    :
                  </span>{' '}
                  <span>0</span>
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BarcodePreview;
